import "./ColumnChart.css";

function toPositiveNumber(value) {
  const normalized = Number(value ?? 0);
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return 0;
  }

  return normalized;
}

function getColumnTotal(column) {
  return (column.segments ?? []).reduce((sum, segment) => sum + toPositiveNumber(segment.value), 0);
}

function getColumnScaleMax(column) {
  return Math.max(getColumnTotal(column), toPositiveNumber(column.markerValue));
}

function buildGroupRows(showValueLabels, showLabels) {
  return [
    showValueLabels ? "auto" : null,
    "minmax(0, 1fr)",
    showLabels ? "auto" : null
  ].filter(Boolean).join(" ");
}

export function ColumnChart({
  columns = [],
  minTrackHeight = "8rem",
  showLabels = true,
  showInlineLabels = false,
  showValueLabels = true
}) {
  const maxTotal = columns.reduce((currentMax, column) => Math.max(currentMax, getColumnScaleMax(column)), 0);
  const groupRows = buildGroupRows(showValueLabels, showLabels);

  return (
    <div class="column-chart">
      <div
        class="column-chart-plot"
        style={{ gridTemplateColumns: `repeat(${Math.max(columns.length, 1)}, minmax(0, 1fr))` }}
      >
        {columns.map((column) => {
          const columnTotal = getColumnTotal(column);
          const title = columnTotal > 0 ? column.title ?? "" : "";

          return (
            <div key={column.key} class="column-chart-group" role="img" title={title} style={{ gridTemplateRows: groupRows }}>
              {showValueLabels ? (
                <div class="column-chart-value">{column.valueLabel ?? "\u00A0"}</div>
              ) : null}
              <div class="column-chart-stack" style={{ minHeight: minTrackHeight }}>
                {columnTotal > 0 && toPositiveNumber(column.markerValue) > 0 ? (
                  <div
                    class="column-chart-marker"
                    style={{ bottom: `${maxTotal > 0 ? (toPositiveNumber(column.markerValue) / maxTotal) * 100 : 0}%` }}
                  />
                ) : null}
                {(column.segments ?? []).map((segment, index) => {
                  const value = toPositiveNumber(segment.value);
                  if (value <= 0) {
                    return null;
                  }

                  const height = maxTotal > 0 ? (value / maxTotal) * 100 : 0;
                  return (
                    <div
                      key={segment.key ?? `${column.key}-${index}`}
                      class={`column-chart-segment tone-${segment.tone ?? "default"}`}
                      style={{ height: `${height}%` }}
                    />
                  );
                })}
                {showInlineLabels && columnTotal > 0 ? (
                  <div class="column-chart-inline-label">{column.inlineLabel ?? column.label}</div>
                ) : null}
              </div>
              {showLabels ? (
                <div class="column-chart-label">{column.label}</div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
